import { useCallback, useEffect, useRef, useState } from 'react';

import { getUserPlatform, osMap } from 'utils/getUserOs';

export const useIsScreenShoting = () => {
  const [isScreenShoting, setIsScreenShoting] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleDetectScreenShot = useCallback(() => {
    setIsScreenShoting(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsScreenShoting(false), 15_000);
  }, []);

  useEffect(
    function handleDesktopEvents() {
      const platform = getUserPlatform();

      const handleKeyEvent = (event: KeyboardEvent) => {
        if (platform === osMap.mac && event.metaKey && event.shiftKey) {
          handleDetectScreenShot();
        }

        if (
          platform === osMap.win &&
          (event.metaKey ||
            event.shiftKey ||
            event.key === 'PrintScreen' ||
            event.key === 'PrintScrn' ||
            event.key === 'PrtSc' ||
            event.key === 'PrtScn' ||
            event.key === 'End')
        ) {
          handleDetectScreenShot();
        }
      };

      if (platform === osMap.mac || platform === osMap.win) {
        window.addEventListener('keyup', handleKeyEvent);
        window.addEventListener('keydown', handleKeyEvent);
      }

      return () => {
        window.removeEventListener('keyup', handleKeyEvent);
        window.removeEventListener('keydown', handleKeyEvent);
      };
    },
    [handleDetectScreenShot]
  );

  useEffect(
    function handleMobileEvents() {
      const platform = getUserPlatform();

      // Mobile: use visibilitychange as a weak proxy
      const handleVisibilityChange = () => {
        if ((platform === osMap.android || platform === osMap.ios) && document.visibilityState === 'hidden') {
          handleDetectScreenShot();
        }
      };

      if (platform === osMap.android || platform === osMap.ios) {
        document.addEventListener('visibilitychange', handleVisibilityChange);
      }

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);

        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    },
    [handleDetectScreenShot]
  );

  return isScreenShoting;
};
